/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'goal-content.goal-about-content.description-title': 'Description',
  'goal-content.goal-about-content.placeholder-description':
    "Décrivez brièvement pourquoi cet objectif est important et comment sa réussite est mesurée, afin de permettre aux abonnés de comprendre l'essentiel.",
  'goal-content.goal-content-updates.add-update': 'Ajouter une mise à jour',
  'goal-content.goal-content-updates.archived': 'Archivés',
  'goal-content.goal-content-updates.at-risk': 'À risque',
  'goal-content.goal-content-updates.cancelled': 'Annulé',
  'goal-content.goal-content-updates.completed': 'Terminé(s) 🎉',
  'goal-content.goal-content-updates.date-changed': 'Date modifiée',
  'goal-content.goal-content-updates.edit-update': 'Modifier',
  "goal-content.goal-content-updates.for-date'": 'pour le {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Dernière mise à jour',
  'goal-content.goal-content-updates.missed-update-message': "Aucune mise à jour n'a été publiée",
  'goal-content.goal-content-updates.new-due-date': "Nouvelle date d'échéance",
  'goal-content.goal-content-updates.new-state': 'Nouvel état',
  'goal-content.goal-content-updates.no-updates-description': "Il n'y a pas encore de mise à jour pour cet objectif.",
  'goal-content.goal-content-updates.off-track': 'Compromis',
  'goal-content.goal-content-updates.old-due-date': "Ancienne date d'échéance",
  'goal-content.goal-content-updates.old-state': 'Ancien état',
  'goal-content.goal-content-updates.on-track': 'Sur la bonne voie',
  'goal-content.goal-content-updates.paused': 'Interrompu(s)',
  'goal-content.goal-content-updates.pending': 'En attente',
  'goal-content.goal-content-updates.previous-updates-title': 'Mises à jour précédentes',
  'goal-content.goal-content-updates.share-update': 'Partager',
  'goal-content.goal-content-updates.status-changed': 'État changé',
  'goal-content.goal-content-updates.write-update-button': 'Rédiger une mise à jour',
};
